<template>
    <b-card no-body class="overflow-hidden">
        <!-- ============ FİLTRE ============ -->
        <div class="p-1 border-bottom">
            <div class="row align-items-end gy-50">
                <div class="col-lg-3 col-md-6 mb-50">
                    <label class="form-label text-secondary mb-25">Personel Ara</label>
                    <input class="form-control" v-model="filter.Query" placeholder="TC / Ad Soyad / Sicil"
                        v-on:keypress.enter="get(1)" />
                </div>
                <div class="col-lg-2 col-md-6 mb-50">
                    <label class="form-label text-secondary mb-25">Çıkış Tarihi (Baş.)</label>
                    <v-date-picker v-model="filter.ExitDateFrom" for-back placeholder="Başlangıç"></v-date-picker>
                </div>
                <div class="col-lg-2 col-md-6 mb-50">
                    <label class="form-label text-secondary mb-25">Çıkış Tarihi (Bitiş)</label>
                    <v-date-picker v-model="filter.ExitDateTo" for-back placeholder="Bitiş"></v-date-picker>
                </div>
                <div class="col-lg-3 col-md-6 mb-50">
                    <label class="form-label text-secondary mb-25">SGK Şube</label>
                    <v-select-list append-to-body multiple :options="sgkBranches" label="Name"
                        v-model="selectedSgkBranches" placeholder="Tümü"></v-select-list>
                </div>
                <div class="col-lg-2 col-md-6 mb-50">
                    <label class="form-label text-secondary mb-25">Kayıt Durumu</label>
                    <select class="form-control bg-img-none" v-model="filter.TaskState">
                        <option :value="1">Eksik bilgili</option>
                        <option :value="3">Bilgileri tam</option>
                        <option :value="2">Çıkış görevi olmayan</option>
                        <option :value="0">Tümü</option>
                    </select>
                </div>

                <!-- Alan bazlı dolu/boş filtreleri -->
                <div class="col-lg-2 col-md-4 mb-50">
                    <label class="form-label text-secondary mb-25">Çıkış Nedeni</label>
                    <select class="form-control bg-img-none" v-model="filter.JobExitCauseFilled">
                        <option :value="null">Tümü</option>
                        <option :value="false">Boş olanlar</option>
                        <option :value="true">Dolu olanlar</option>
                    </select>
                </div>
                <div class="col-lg-2 col-md-4 mb-50">
                    <label class="form-label text-secondary mb-25">Özel Neden</label>
                    <select class="form-control bg-img-none" v-model="filter.SpecialCauseFilled">
                        <option :value="null">Tümü</option>
                        <option :value="false">Boş olanlar</option>
                        <option :value="true">Dolu olanlar</option>
                    </select>
                </div>
                <div class="col-lg-2 col-md-4 mb-50">
                    <label class="form-label text-secondary mb-25">SGK Çıkış Kodu</label>
                    <select class="form-control bg-img-none" v-model="filter.SGKExitCodeFilled">
                        <option :value="null">Tümü</option>
                        <option :value="false">Boş olanlar</option>
                        <option :value="true">Dolu olanlar</option>
                    </select>
                </div>
                <div class="col-lg-2 col-md-4 mb-50">
                    <label class="form-label text-secondary mb-25">Tebliğ Tarihi</label>
                    <select class="form-control bg-img-none" v-model="filter.NotifyDateFilled">
                        <option :value="null">Tümü</option>
                        <option :value="false">Boş olanlar</option>
                        <option :value="true">Dolu olanlar</option>
                    </select>
                </div>
                <div class="col-lg-2 col-md-4 mb-50">
                    <label class="form-label text-secondary mb-25">Sıralama</label>
                    <select class="form-control bg-img-none" v-model="filter.SortBy">
                        <option :value="0">Çıkış tarihi (yeni→eski)</option>
                        <option :value="1">Çıkış tarihi (eski→yeni)</option>
                        <option :value="2">Ada göre (A→Z)</option>
                    </select>
                </div>
                <div class="col-lg-2 col-md-4 mb-50">
                    <b-form-checkbox v-model="filter.OnlyDuplicates" class="mt-1">
                        <small>Sadece mükerrer kayıtlar</small>
                    </b-form-checkbox>
                </div>

                <div class="col-12 mt-50">
                    <button class="btn btn-success" v-on:click="get(1)">Sorgula</button>
                    <button class="btn btn-outline-secondary ml-50" v-on:click="resetFilter">Filtreyi Temizle</button>
                </div>
            </div>
        </div>

        <!-- ============ AKSİYON ÇUBUĞU ============ -->
        <div class="p-1 border-bottom bg-light d-flex align-items-center flex-wrap g-50"
            v-if="(items || []).length">
            <b-form-checkbox :checked="allSelected" v-on:change="toggleAll" class="mr-1">
                <small>Sayfadakileri seç</small>
            </b-form-checkbox>
            <span class="text-muted mr-1"><small>Seçili: <strong>{{ selectedIds.length }}</strong></small></span>
            <span class="text-warning mr-auto" v-if="dirtyCount > 0">
                <small>Kaydedilmemiş değişiklik: <strong>{{ dirtyCount }}</strong></small>
            </span>
            <button class="btn btn-sm btn-outline-primary mr-50" v-on:click="openBulk"
                :disabled="selectedIds.length == 0 && count == 0">
                Toplu Ata
            </button>
            <v-executer :loading="saving" :action="save" class="btn-sm" variant="success"
                :disabled="dirtyCount == 0">
                Kaydet ({{ dirtyCount }})
            </v-executer>
        </div>

        <!-- ============ LİSTE (satır içi düzenleme) ============ -->
        <b-overlay :show="getting" opacity="0.5">
            <div class="table-responsive mb-0">
                <table class="table table-sm table-hover mb-0">
                    <thead>
                        <tr>
                            <th style="width:34px"></th>
                            <th class="text-nowrap">Personel</th>
                            <th class="text-nowrap">Kimlik No</th>
                            <th class="text-nowrap">Çıkış Tarihi</th>
                            <th class="text-nowrap">Şube</th>
                            <th style="min-width:170px">Çıkış Nedeni</th>
                            <th style="min-width:190px">Özel Neden</th>
                            <th style="min-width:200px">Alt Neden</th>
                            <th style="min-width:230px">SGK Çıkış Nedeni</th>
                            <th class="text-center text-nowrap">Durum</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="(items || []).length == 0">
                            <td colspan="11" class="text-center py-2 text-muted">Kayıt bulunamadı.</td>
                        </tr>
                        <tr v-for="(v, i) in items" :key="v.ExitNoticeId"
                            :class="{ 'table-warning': isDirty(v) }">
                            <td>
                                <b-form-checkbox :checked="selectedIds.includes(v.ExitNoticeId)"
                                    v-on:change="toggleOne(v.ExitNoticeId)" />
                            </td>
                            <td class="text-nowrap font-weight-bold">
                                {{ v.FullName }}
                                <feather-icon icon="AlertTriangleIcon" size="14" class="text-danger ml-25"
                                    v-if="v.IsDuplicate" v-b-tooltip.hover
                                    title="Bu personelin aynı gün birden fazla çıkış kaydı var (veri tutarsızlığı)." />
                            </td>
                            <td class="text-nowrap">{{ v.IdentityNumber }}</td>
                            <td class="text-nowrap">{{ v.ExitDateStr }}</td>
                            <td class="text-nowrap"><small>{{ v.SGKBranchName }}</small></td>

                            <td>
                                <v-select-list append-to-body :options="causes" label="Name"
                                    :value="findById(causes, v.JobExitCauseId, v.JobExitCauseName)"
                                    v-on:input="onCauseChange(v, $event)" placeholder="Seçiniz"></v-select-list>
                            </td>
                            <td>
                                <v-select-list append-to-body :options="parentCauses" label="Name"
                                    :value="findById(parentCauses, v.ParentSpecialCauseId, v.ParentSpecialCauseName)"
                                    v-on:input="onParentChange(v, $event)" placeholder="Seçiniz"></v-select-list>
                            </td>
                            <td>
                                <v-select-list append-to-body :options="subCausesOf(v)" label="Name"
                                    :value="findById(subCausesOf(v), v.SubSpecialCauseId, v.SubSpecialCauseName)"
                                    :disabled="!v.ParentSpecialCauseId"
                                    v-on:input="onSubChange(v, $event)"
                                    :placeholder="v.ParentSpecialCauseId ? 'Seçiniz' : 'Önce özel neden'"></v-select-list>
                            </td>
                            <td>
                                <v-select-list append-to-body :options="sgkCauses" label="Value"
                                    :value="findByCode(sgkCauses, v.SGKExitCauseCode, v.SGKExitCauseName)"
                                    v-on:input="onSgkChange(v, $event)" placeholder="Seçiniz"></v-select-list>
                            </td>
                            <td class="text-center text-nowrap">
                                <span class="badge badge-light-success" v-if="v.IsComplete">Tam</span>
                                <span class="badge badge-light-danger" v-else v-b-tooltip.hover
                                    :title="'Eksik: ' + (v.MissingFields || []).join(', ')">
                                    {{ (v.MissingFields || []).length }} eksik
                                </span>
                            </td>
                            <td class="text-right">
                                <button class="btn btn-sm btn-outline-primary text-nowrap"
                                    v-on:click="openDetail(v)">Detay</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="p-1 d-flex align-items-center flex-wrap" v-if="count > 0">
                <select class="form-control w-auto mr-1" v-model="perPage">
                    <option v-for="p in perPages" :key="p" :value="p">{{ p }}</option>
                </select>
                <span class="text-muted mr-auto"><small>Toplam {{ count }} kayıt</small></span>
                <b-pagination v-model="page" :total-rows="count" :per-page="perPage" class="mb-0" />
            </div>
        </b-overlay>

        <!-- ============ DETAY MODALI ============ -->
        <b-modal v-model="detailOpen" size="lg" title="Çıkış Detayı" ok-only ok-title="Kapat"
            v-if="detail">
            <div class="row">
                <div class="col-12 mb-1">
                    <div class="alert alert-secondary p-1 mb-0">
                        <strong>{{ detail.FullName }}</strong>
                        <span class="text-muted"> — {{ detail.IdentityNumber }} — Çıkış: {{ detail.ExitDateStr }}</span>
                    </div>
                </div>
                <div class="col-md-4 mb-1">
                    <label class="form-label text-secondary">Tebliğ (Bildirim) Tarihi</label>
                    <v-date-picker v-model="detail.NotifyDate" for-back placeholder="Tebliğ Tarihi"
                        v-on:input="markDirty(detail)"></v-date-picker>
                </div>
                <div class="col-md-4 mb-1">
                    <label class="form-label text-secondary">Meslek Kodu</label>
                    <input class="form-control" v-model="detail.MeslekKodu" v-on:input="markDirty(detail)" />
                </div>
                <div class="col-md-4 mb-1">
                    <label class="form-label text-secondary">CSGB İş Kolu</label>
                    <v-select-list append-to-body :options="csgbList" label="Value"
                        :value="findByCode(csgbList, detail.CsgbIsKolu, detail.CsgbIsKolu)"
                        v-on:input="onCsgbChange(detail, $event)" placeholder="Seçiniz"></v-select-list>
                </div>

                <div class="col-md-4 mb-1">
                    <b-form-checkbox v-model="detail.IhbarOneliKullanildi" v-on:input="markDirty(detail)">
                        İhbar Öneli Kullanıldı
                    </b-form-checkbox>
                </div>
                <div class="col-md-4 mb-1" v-if="detail.IhbarOneliKullanildi">
                    <label class="form-label text-secondary">İhbar Öneli Süresi (gün)</label>
                    <input type="number" class="form-control" v-model.number="detail.IhbarOneliSuresi"
                        v-on:input="markDirty(detail)" />
                </div>
                <div class="col-md-4 mb-1">
                    <label class="form-label text-secondary">Şirkete Borcu</label>
                    <input type="number" class="form-control" v-model.number="detail.SirketeBorcu"
                        v-on:input="markDirty(detail)" />
                </div>

                <div class="col-12"><hr class="my-50" /></div>

                <div class="col-md-3 mb-1">
                    <b-form-checkbox v-model="detail.EYT" v-on:input="markDirty(detail)">EYT</b-form-checkbox>
                </div>
                <div class="col-md-3 mb-1">
                    <b-form-checkbox v-model="detail.Dummy" v-on:input="markDirty(detail)">
                        Dummy (Temsili)
                    </b-form-checkbox>
                </div>
                <div class="col-md-3 mb-1">
                    <b-form-checkbox v-model="detail.Driver" v-on:input="markDirty(detail)">Şoför</b-form-checkbox>
                </div>
                <div class="col-md-3 mb-1">
                    <b-form-checkbox v-model="detail.Ihtar" v-on:input="markDirty(detail)">İhtar</b-form-checkbox>
                </div>

                <div class="col-md-4 mb-1">
                    <b-form-checkbox v-model="detail.Vukuat" v-on:input="markDirty(detail)">Vukuat</b-form-checkbox>
                </div>
                <div class="col-md-8 mb-1" v-if="detail.Vukuat">
                    <label class="form-label text-secondary">Vukuat Açıklaması</label>
                    <input class="form-control" v-model="detail.VukuatAciklama" v-on:input="markDirty(detail)" />
                </div>

                <div class="col-md-4 mb-1">
                    <b-form-checkbox v-model="detail.Harmful" v-on:input="markDirty(detail)">
                        Tekrar İşe Alım Sakıncalı
                    </b-form-checkbox>
                </div>
                <div class="col-md-8 mb-1" v-if="detail.Harmful">
                    <label class="form-label text-secondary">Sakınca Nedeni</label>
                    <input class="form-control" v-model="detail.HarmfulReason" v-on:input="markDirty(detail)" />
                </div>

                <div class="col-12"><hr class="my-50" /></div>

                <div class="col-md-6 mb-1">
                    <b-form-checkbox v-model="detail.Arabuluculuk" v-on:input="markDirty(detail)">
                        Arabuluculuk Var
                    </b-form-checkbox>
                </div>
                <div class="col-md-6 mb-1" v-if="detail.Arabuluculuk">
                    <label class="form-label text-secondary">Anlaşma Sağlandı mı?</label>
                    <select class="form-control bg-img-none" v-model="detail.ArabuluculukAnlasma"
                        v-on:change="markDirty(detail)">
                        <option :value="null">Belirtilmedi</option>
                        <option :value="true">Evet</option>
                        <option :value="false">Hayır</option>
                    </select>
                </div>
                <div class="col-12" v-if="detail.Arabuluculuk">
                    <small class="text-muted">
                        Arabuluculuk ödemeleri "Arabuluculuk" ekranından girilir.
                    </small>
                </div>
            </div>
        </b-modal>

        <!-- ============ TOPLU ATAMA MODALI ============ -->
        <b-modal v-model="bulkOpen" title="Toplu Atama" ok-title="Uygula" cancel-title="Vazgeç"
            v-on:ok="applyBulk" :ok-disabled="bulkApplying" size="md" body-class="bulk-modal">

            <!-- Hedef özeti -->
            <div class="bulk-target">
                <div class="bulk-target__count">{{ bulkTargetCount }}</div>
                <div class="bulk-target__text">
                    <strong>kayıt güncellenecek</strong>
                    <div class="text-muted">
                        <small>{{ selectedIds.length > 0 ? "Listeden seçtiğiniz kayıtlar" : "Filtre sonucunun tamamı" }}</small>
                    </div>
                </div>
            </div>

            <!-- Yazma davranışı -->
            <div class="bulk-mode">
                <b-form-checkbox v-model="bulk.OnlyFillEmpty" switch>
                    <span class="font-weight-bold">Sadece boş alanları doldur</span>
                    <div class="text-muted mt-25">
                        <small v-if="bulk.OnlyFillEmpty">Dolu alanların üzerine yazılmaz.</small>
                        <small v-else class="text-danger">Dolu alanların üzerine YAZILIR.</small>
                    </div>
                </b-form-checkbox>
            </div>

            <div class="bulk-hint">Uygulanacak alanları işaretleyiniz</div>

            <!-- Alanlar -->
            <div class="bulk-field" :class="{ 'bulk-field--on': bulk.ApplyJobExitCause }">
                <b-form-checkbox v-model="bulk.ApplyJobExitCause">Çıkış Nedeni</b-form-checkbox>
                <v-select-list append-to-body class="mt-50" :options="causes" label="Name" v-model="bulkCause"
                    :disabled="!bulk.ApplyJobExitCause" placeholder="Seçiniz"></v-select-list>
            </div>

            <div class="bulk-field" :class="{ 'bulk-field--on': bulk.ApplyParentSpecialCause }">
                <b-form-checkbox v-model="bulk.ApplyParentSpecialCause">Özel Neden</b-form-checkbox>
                <v-select-list append-to-body class="mt-50" :options="parentCauses" label="Name" v-model="bulkParent"
                    :disabled="!bulk.ApplyParentSpecialCause" placeholder="Seçiniz"></v-select-list>
            </div>

            <div class="bulk-field" :class="{ 'bulk-field--on': bulk.ApplySGKExitCause }">
                <b-form-checkbox v-model="bulk.ApplySGKExitCause">SGK Çıkış Nedeni</b-form-checkbox>
                <v-select-list append-to-body class="mt-50" :options="sgkCauses" label="Value" v-model="bulkSgk"
                    :disabled="!bulk.ApplySGKExitCause" placeholder="Seçiniz"></v-select-list>
            </div>

            <div class="row">
                <div class="col-6">
                    <div class="bulk-field h-100" :class="{ 'bulk-field--on': bulk.ApplyEYT }">
                        <b-form-checkbox v-model="bulk.ApplyEYT">EYT</b-form-checkbox>
                        <select class="form-control bg-img-none mt-50" v-model="bulk.EYT" :disabled="!bulk.ApplyEYT">
                            <option :value="true">Evet</option>
                            <option :value="false">Hayır</option>
                        </select>
                    </div>
                </div>
                <div class="col-6">
                    <div class="bulk-field h-100" :class="{ 'bulk-field--on': bulk.ApplyDummy }">
                        <b-form-checkbox v-model="bulk.ApplyDummy">Dummy (Temsili)</b-form-checkbox>
                        <select class="form-control bg-img-none mt-50" v-model="bulk.Dummy" :disabled="!bulk.ApplyDummy">
                            <option :value="true">Evet</option>
                            <option :value="false">Hayır</option>
                        </select>
                    </div>
                </div>
            </div>
        </b-modal>
    </b-card>
</template>

<script>
import { BCard, BOverlay, BPagination, BModal, BFormCheckbox, VBTooltip } from "bootstrap-vue";
import EmployeeOperationsApi from "@/api/employee-operations";
import HumanResourcesParameterApi from "@/api/human-resources-parameters";
import CompanyApi from "@/api/company";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

// Değişiklikleri tespit ederken karşılaştırılan alanlar (satır içi + detay).
const TRACKED = [
    "NotifyDate", "JobExitCauseId", "ParentSpecialCauseId", "SubSpecialCauseId",
    "SGKExitCauseCode", "EYT", "Dummy", "Harmful", "HarmfulReason",
    "MeslekKodu", "CsgbIsKolu", "IhbarOneliKullanildi", "IhbarOneliSuresi",
    "Driver", "Ihtar", "Vukuat", "VukuatAciklama", "SirketeBorcu",
    "Arabuluculuk", "ArabuluculukAnlasma",
];

export default {
    components: { BCard, BOverlay, BPagination, BModal, BFormCheckbox },
    directives: { "b-tooltip": VBTooltip },
    data() {
        return {
            getting: false,
            saving: false,
            bulkApplying: false,
            items: [],
            original: {},          // ExitNoticeId -> ilk yüklenen hali (dirty tespiti)
            count: 0,
            page: 1,
            perPage: 50,
            perPages: [25, 50, 100, 200],
            selectedIds: [],

            filter: this.emptyFilter(),
            sgkBranches: [],
            selectedSgkBranches: [],

            causes: [],
            parentCauses: [],
            subCauseCache: {},     // parentId -> alt neden listesi
            sgkCauses: [],
            csgbList: [],

            detailOpen: false,
            detail: null,

            bulkOpen: false,
            bulk: this.emptyBulk(),
            bulkCause: null,
            bulkParent: null,
            bulkSgk: null,
        };
    },
    computed: {
        dirtyCount() {
            return (this.items || []).filter((x) => this.isDirty(x)).length;
        },
        allSelected() {
            return (this.items || []).length > 0 &&
                this.items.every((x) => this.selectedIds.includes(x.ExitNoticeId));
        },
        bulkTargetCount() {
            return this.selectedIds.length > 0 ? this.selectedIds.length : this.count;
        },
    },
    watch: {
        page() { this.get(); },
        perPage() { this.get(1); },
    },
    mounted() {
        this.getLookups();
        this.get(1);
    },
    methods: {
        emptyFilter() {
            return {
                Query: null,
                SGKBranchIds: [], OperationalBranchIds: [], CollarStatusIds: [],
                ExitDateFrom: null, ExitDateTo: null,
                JobExitCauseIds: [], ParentSpecialCauseIds: [],
                JobExitCauseFilled: null, SpecialCauseFilled: null,
                SGKExitCodeFilled: null, NotifyDateFilled: null,
                EYT: null, Dummy: null, Harmful: null,
                TaskState: 1,          // varsayılan: eksik bilgili
                OnlyDuplicates: false,
                SortBy: 0,
            };
        },
        emptyBulk() {
            return {
                OnlyFillEmpty: true,
                ApplyJobExitCause: false, ApplyParentSpecialCause: false,
                ApplySubSpecialCause: false, ApplySGKExitCause: false,
                ApplyNotifyDate: false, ApplyMeslekKodu: false, ApplyCsgbIsKolu: false,
                ApplyEYT: false, EYT: false,
                ApplyDummy: false, Dummy: false,
            };
        },
        resetFilter() {
            this.filter = this.emptyFilter();
            this.selectedSgkBranches = [];
            this.get(1);
        },

        // ---------- lookup ----------
        getLookups() {
            HumanResourcesParameterApi.JobExitCause.List().then((res) => {
                if (res.data.Success) this.causes = res.data.Data || [];
            });
            HumanResourcesParameterApi.JobExitSpecialCause.ParentList().then((res) => {
                if (res.data.Success) this.parentCauses = res.data.Data || [];
            }).catch(() => { });
            EmployeeOperationsApi.Employee.SGK.Type("istenCikisNedeni").then((res) => {
                if (res.data.Success) this.sgkCauses = res.data.Data || [];
            }).catch(() => { });
            EmployeeOperationsApi.Employee.SGK.Type("csgbiskolu").then((res) => {
                if (res.data.Success) this.csgbList = res.data.Data || [];
            }).catch(() => { });
            CompanyApi.Branch.ListByCode("S").then((res) => {
                if (res.data.Success) this.sgkBranches = res.data.Data || [];
            }).catch(() => { });
        },
        subCausesOf(row) {
            if (!row.ParentSpecialCauseId) return [];
            const cached = this.subCauseCache[row.ParentSpecialCauseId];
            if (cached) return cached;
            // İlk istek: önbelleğe al, tekrar tekrar çağırma.
            this.$set(this.subCauseCache, row.ParentSpecialCauseId, []);
            HumanResourcesParameterApi.JobExitSpecialCause
                .ListGetById(row.ParentSpecialCauseId)
                .then((res) => {
                    if (res.data.Success)
                        this.$set(this.subCauseCache, row.ParentSpecialCauseId, res.data.Data || []);
                }).catch(() => { });
            return [];
        },
        // Lookup listesi henüz yüklenmemişse (ya da alt neden listesi asenkron
        // geliyorsa) eşleşme bulunamaz ve dolu kayıt "Seçiniz" görünürdü.
        // Bu durumda satırdaki mevcut ADI kullanarak geçici bir seçenek üretiyoruz,
        // böylece kullanıcı kayıtlı değeri her zaman görür.
        findById(list, id, fallbackName) {
            if (!id) return null;
            const hit = (list || []).find((x) => x.Id == id);
            if (hit) return hit;
            return fallbackName ? { Id: id, Name: fallbackName } : null;
        },
        findByCode(list, code, fallbackName) {
            if (!code) return null;
            const hit = (list || []).find((x) => x.Code == code);
            if (hit) return hit;
            return { Code: code, Value: fallbackName || code };
        },

        // ---------- liste ----------
        buildFilter() {
            return {
                ...this.filter,
                SGKBranchIds: (this.selectedSgkBranches || []).map((x) => x.Id),
                PaginateRequest: {
                    Skip: (this.page - 1) * this.perPage,
                    Take: this.perPage,
                },
            };
        },
        get(page) {
            if (page) this.page = page;
            if (this.dirtyCount > 0 &&
                !confirm("Kaydedilmemiş değişiklikler var. Yine de listeyi yenilemek istiyor musunuz?")) return;
            this.getting = true;
            this.selectedIds = [];
            EmployeeOperationsApi.OldExitList(this.buildFilter())
                .then((res) => {
                    if (res.data.Success) {
                        this.items = this.$safe(res.data, "Data.Data") || [];
                        this.count = this.$safe(res.data, "Data.TotalCount") || 0;
                        this.original = {};
                        this.items.forEach((x) => {
                            this.original[x.ExitNoticeId] = this.snapshot(x);
                        });
                        // Satırlarda kullanılan alt neden listelerini önden yükle;
                        // aksi halde dolu olan alt neden seçimi ekranda görünmez.
                        this.preloadSubCauses();
                    }
                    this.getting = false;
                })
                .catch(() => { this.getting = false; });
        },
        preloadSubCauses() {
            const parents = [...new Set((this.items || [])
                .map((x) => x.ParentSpecialCauseId)
                .filter((x) => x))];
            parents.forEach((pid) => {
                if (this.subCauseCache[pid]) return;
                this.$set(this.subCauseCache, pid, []);
                HumanResourcesParameterApi.JobExitSpecialCause.ListGetById(pid)
                    .then((res) => {
                        if (res.data.Success)
                            this.$set(this.subCauseCache, pid, res.data.Data || []);
                    }).catch(() => { });
            });
        },
        snapshot(row) {
            const o = {};
            TRACKED.forEach((k) => { o[k] = row[k]; });
            return JSON.stringify(o);
        },
        isDirty(row) {
            const before = this.original[row.ExitNoticeId];
            return before != null && before !== this.snapshot(row);
        },
        markDirty() { this.$forceUpdate(); },

        // ---------- satır içi değişiklikler ----------
        onCauseChange(row, v) { row.JobExitCauseId = v ? v.Id : null; this.markDirty(); },
        onParentChange(row, v) {
            row.ParentSpecialCauseId = v ? v.Id : null;
            row.SubSpecialCauseId = null;      // üst değişince alt seçim geçersizdir
            this.markDirty();
        },
        onSubChange(row, v) { row.SubSpecialCauseId = v ? v.Id : null; this.markDirty(); },
        onSgkChange(row, v) { row.SGKExitCauseCode = v ? v.Code : null; this.markDirty(); },
        onCsgbChange(row, v) { row.CsgbIsKolu = v ? v.Code : null; this.markDirty(); },

        toggleOne(id) {
            const i = this.selectedIds.indexOf(id);
            if (i >= 0) this.selectedIds.splice(i, 1);
            else this.selectedIds.push(id);
        },
        toggleAll() {
            if (this.allSelected) this.selectedIds = [];
            else this.selectedIds = this.items.map((x) => x.ExitNoticeId);
        },

        openDetail(row) { this.detail = row; this.detailOpen = true; },

        // ---------- kaydetme ----------
        save() {
            const changed = (this.items || []).filter((x) => this.isDirty(x));
            if (!changed.length) return Promise.resolve();
            this.saving = true;
            const payload = {
                Items: changed.map((x) => ({
                    ExitNoticeId: x.ExitNoticeId,
                    NotifyDate: x.NotifyDate,
                    JobExitCauseId: x.JobExitCauseId,
                    ParentSpecialCauseId: x.ParentSpecialCauseId,
                    SubSpecialCauseId: x.SubSpecialCauseId,
                    SGKExitCauseCode: x.SGKExitCauseCode,
                    EYT: x.EYT, Dummy: x.Dummy,
                    Harmful: x.Harmful, HarmfulReason: x.HarmfulReason,
                    MeslekKodu: x.MeslekKodu, CsgbIsKolu: x.CsgbIsKolu,
                    IhbarOneliKullanildi: x.IhbarOneliKullanildi,
                    IhbarOneliSuresi: x.IhbarOneliSuresi,
                    Driver: x.Driver, Ihtar: x.Ihtar,
                    Vukuat: x.Vukuat, VukuatAciklama: x.VukuatAciklama,
                    SirketeBorcu: x.SirketeBorcu,
                    Arabuluculuk: x.Arabuluculuk,
                    ArabuluculukAnlasma: x.ArabuluculukAnlasma,
                })),
            };
            return EmployeeOperationsApi.OldExitSave(payload)
                .then((res) => {
                    this.saving = false;
                    const d = res.data?.Data;
                    if (res.data?.Success) {
                        let msg = `${d?.UpdatedCount || 0} kayıt güncellendi.`;
                        if (d?.CreatedTaskCount) msg += ` ${d.CreatedTaskCount} çıkış görevi oluşturuldu.`;
                        this.$toast({ component: ToastificationContent, props: { title: "Kaydedildi", icon: "CheckCircleIcon", variant: "success", text: msg } });
                        this.get();
                    } else {
                        const errs = (d?.Errors || []).join("\n") || res.data?.Message;
                        alert(errs || "Kayıt sırasında hata oluştu.");
                    }
                })
                .catch(() => { this.saving = false; });
        },

        // ---------- toplu atama ----------
        openBulk() {
            this.bulk = this.emptyBulk();
            this.bulkCause = null; this.bulkParent = null; this.bulkSgk = null;
            this.bulkOpen = true;
        },
        applyBulk(evt) {
            if (evt) evt.preventDefault();
            const req = {
                ...this.bulk,
                ExitNoticeIds: this.selectedIds,
                Filter: this.selectedIds.length > 0 ? null : this.buildFilter(),
                JobExitCauseId: this.bulkCause ? this.bulkCause.Id : null,
                ParentSpecialCauseId: this.bulkParent ? this.bulkParent.Id : null,
                SGKExitCauseCode: this.bulkSgk ? this.bulkSgk.Code : null,
            };
            if (!req.ApplyJobExitCause && !req.ApplyParentSpecialCause &&
                !req.ApplySGKExitCause && !req.ApplyEYT && !req.ApplyDummy) {
                alert("En az bir alan seçmelisiniz.");
                return;
            }
            if (!confirm(`${this.bulkTargetCount} kayıt güncellenecek. Onaylıyor musunuz?`)) return;

            this.bulkApplying = true;
            EmployeeOperationsApi.OldExitBulkAssign(req)
                .then((res) => {
                    this.bulkApplying = false;
                    const d = res.data?.Data;
                    if (res.data?.Success) {
                        let msg = `${d?.UpdatedCount || 0} kayıt güncellendi.`;
                        if (d?.SkippedCount) msg += ` ${d.SkippedCount} kayıt atlandı.`;
                        if (d?.CreatedTaskCount) msg += ` ${d.CreatedTaskCount} çıkış görevi oluşturuldu.`;
                        this.$toast({ component: ToastificationContent, props: { title: "Toplu atama", icon: "CheckCircleIcon", variant: "success", text: msg } });
                        this.bulkOpen = false;
                        this.get();
                    } else {
                        alert(res.data?.Message || "Toplu atama sırasında hata oluştu.");
                    }
                })
                .catch(() => { this.bulkApplying = false; });
        },
    },
};
</script>

<style scoped>
/* Toplu atama modalı: alanlar arası nefes + seçili alanın vurgusu */
.bulk-modal {
    padding: 1.25rem;
}

/* Hedef özeti */
.bulk-target {
    display: flex;
    align-items: center;
    gap: 0.875rem;
    padding: 0.875rem 1rem;
    margin-bottom: 1.25rem;
    background: #fff8f1;
    border: 1px solid #ffd9b8;
    border-radius: 0.4rem;
}
.bulk-target__count {
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #ff9f43;
    min-width: 2.5rem;
    text-align: center;
}
.bulk-target__text {
    line-height: 1.35;
}

/* Yazma davranışı anahtarı */
.bulk-mode {
    padding: 0.75rem 1rem;
    margin-bottom: 1.25rem;
    background: #f8f8f8;
    border-radius: 0.4rem;
}

/* Bölüm başlığı */
.bulk-hint {
    font-size: 0.8rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: #b9b9c3;
    padding-bottom: 0.5rem;
    margin-bottom: 0.875rem;
    border-bottom: 1px solid #ebe9f1;
}

/* Alan kartı: pasifken soluk, seçilince vurgulu */
.bulk-field {
    padding: 0.875rem 1rem;
    margin-bottom: 0.875rem;
    border: 1px solid #ebe9f1;
    border-radius: 0.4rem;
    transition: border-color 0.15s ease, background-color 0.15s ease;
}
.bulk-field--on {
    border-color: #7367f0;
    background: #f6f5fd;
}
.bulk-field .form-control:disabled,
.bulk-field >>> .vs--disabled .vs__dropdown-toggle {
    opacity: 0.55;
}
.row .bulk-field {
    margin-bottom: 0;
}
</style>
